import getRequest from '../../../../getRequest';

export default async function getAttributeCount(siteId) {
  const endpoint = `/oc-data-management/v1/attributes/attribute-counts/${siteId}`;

  return new Promise((resolve, reject) => {
    getRequest(endpoint, 'Get attribute count')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
